// extracted by mini-css-extract-plugin
module.exports = {"winnerImage":"__1a_winnerImage__ysoOk"};